// extracted by mini-css-extract-plugin
export var actions = "story-item-module--actions--35afb";
export var bottom__black = "story-item-module--bottom__black--9a3c5";
export var bottom__bloodorange = "story-item-module--bottom__bloodorange--77d50";
export var bottom__chartruse = "story-item-module--bottom__chartruse--f54ee";
export var bottom__cobalt = "story-item-module--bottom__cobalt--7a246";
export var bottom__emerald = "story-item-module--bottom__emerald--a5bb7";
export var bottom__paper = "story-item-module--bottom__paper--5adcc";
export var bottom__pink = "story-item-module--bottom__pink--88d49";
export var bottom__sky = "story-item-module--bottom__sky--5ce94";
export var bottom__white = "story-item-module--bottom__white--cf54a";
export var image = "story-item-module--image--a31db";
export var spin = "story-item-module--spin--f467a";
export var story = "story-item-module--story--d96db";
export var storyWrap = "story-item-module--storyWrap--0b01c";
export var storyWrap__blocked = "story-item-module--storyWrap__blocked--f8886";
export var storyWrap__editorial = "story-item-module--storyWrap__editorial--a26f7";
export var story__notSubscribed = "story-item-module--story__notSubscribed--a3eaf";
export var subscribe = "story-item-module--subscribe--bfd46";
export var subscribeAlready = "story-item-module--subscribeAlready--b4ef9";
export var subscribeBottom = "story-item-module--subscribeBottom--b55a1";
export var subscribeWrapper = "story-item-module--subscribeWrapper--ad478";